<template>
  <div class="min-h-screen bg-gradient-to-br from-primary-100 via-white to-primary-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full space-y-8 bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-xl transform transition-all duration-500 hover:shadow-2xl">
      <!-- Logo and Title -->
      <div class="text-center">
        <div class="flex justify-center">
          <div class="w-24 h-24 transform transition-transform duration-500 hover:scale-110">
            <img src="@/assets/logo.svg" alt="Portfolio Tracker Logo" class="w-full h-full" />
          </div>
        </div>
        <h2 class="mt-6 text-center text-3xl font-extrabold bg-gradient-to-r from-primary-600 to-primary-600 bg-clip-text text-transparent">
          Welcome Back
        </h2>
        <p class="mt-2 text-sm text-gray-600 dark:text-gray-400">
          Sign in to access your portfolio
        </p>
      </div>

      <!-- Error Alert -->
      <div v-if="error" class="rounded-lg bg-red-50 dark:bg-red-900/30 p-4 mb-4 transform animate-shake">
        <div class="flex">
          <div class="flex-shrink-0">
            <svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
            </svg>
          </div>
          <div class="ml-3">
            <h3 class="text-sm font-medium text-red-800 dark:text-red-200">
              Authentication Error
            </h3>
            <div class="mt-2 text-sm text-red-700 dark:text-red-300">
              {{ error }}
            </div>
          </div>
        </div>
      </div>

      <!-- Login Button -->
      <div class="mt-8 space-y-6">
        <button
          @click="handleGoogleLogin"
          class="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-lg text-white bg-gradient-to-r from-primary-600 to-primary-600 hover:from-primary-700 hover:to-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transform transition-all duration-150 hover:scale-[1.02] hover:shadow-lg"
        >
          <span class="absolute left-0 inset-y-0 flex items-center pl-3">
            <!-- Google Icon -->
            <svg class="h-5 w-5 text-white opacity-80 group-hover:opacity-100" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M21.35,11.1H12.18V13.83H18.69C18.36,17.64 15.19,19.27 12.19,19.27C8.36,19.27 5,16.25 5,12C5,7.9 8.2,4.73 12.2,4.73C15.29,4.73 17.1,6.7 17.1,6.7L19,4.72C19,4.72 16.56,2 12.1,2C6.42,2 2.03,6.8 2.03,12C2.03,17.05 6.16,22 12.25,22C17.6,22 21.5,18.33 21.5,12.91C21.5,11.76 21.35,11.1 21.35,11.1Z"
              />
            </svg>
          </span>
          <span class="ml-4">Continue with Google</span>
        </button>

        <!-- Divider -->
        <div class="relative">
          <div class="absolute inset-0 flex items-center">
            <div class="w-full border-t border-gray-200 dark:border-gray-700"></div>
          </div>
          <div class="relative flex justify-center text-sm">
            <span class="px-2 bg-white dark:bg-gray-800 text-gray-500 dark:text-gray-400">Protected by Google OAuth</span>
          </div>
        </div>

        <!-- Footer Links -->
        <div class="text-center text-sm">
          <p class="text-gray-600 dark:text-gray-400">
            By signing in, you agree to our
            <a href="#" class="font-medium text-primary-600 dark:text-primary-400 hover:text-primary-500">Terms of Service</a>
            and
            <a href="#" class="font-medium text-primary-600 dark:text-primary-400 hover:text-primary-500">Privacy Policy</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { authService } from '@/services/authService';

export default {
  name: 'LoginPage',
  data() {
    return {
      error: null
    };
  },
  methods: {
    handleGoogleLogin() {
      this.error = null;
      authService.initiateGoogleLogin();
    }
  },
  async mounted() {
    if (this.$route.query.error) {
      this.error = 'Authentication failed. Please try again.';
    }
  }
};
</script>


<style scoped>
@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-8px); }
  75% { transform: translateX(8px); }
}

.animate-shake {
  animation: shake 0.5s cubic-bezier(.36,.07,.19,.97) both;
}
</style> 